import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const DisabledRadioIconV2: FC<IconV2Props> = ({ icon, className }) => (
  <svg
    className={cn(s.svg24, `svg-icon--${icon}`, className)}
    viewBox="3 3 20 20"
  >
    <g
      transform="translate(3 3)"
      stroke="#949797"
      fill="none"
      fillRule="evenodd"
    >
      <circle cx="8.5" cy="8.5" r="8" />
      <path strokeLinecap="square" d="m3.55 13.45 9.9-9.9" />
    </g>
  </svg>
);

export default DisabledRadioIconV2;
